
/**
 * Check if the browser supports the Web Speech API
 */
export function isSupported() {
    return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
}

/**
 * Start listening for speech input.
 * Returns a stop function that can be called to cancel listening.
 * - lang: BCP 47 language tag (e.g. "en", "sv")
 * - onResult: called with the transcript when speech is recognized
 * - onEnd: called when recognition ends (whether by result, error, or manual stop)
 */
export function startListening(lang, onResult, onEnd) {
    const clo = (function(lang, onResult, onEnd) {
            var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            var recognition = new SpeechRecognition();
            recognition.lang = lang;
            recognition.interimResults = false;
            recognition.continuous = false;
            recognition.maxAlternatives = 1;
            recognition.onresult = function(event) {
                var transcript = event.results[0][0].transcript;
                onResult(transcript);
            };
            recognition.onend = function() { onEnd(); };
            recognition.onerror = function() { onEnd(); };
            recognition.start();
            return function() { recognition.abort(); };
        })(lang, onResult, onEnd);
    return () => {
        clo();
    };
}

